import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const HeaderText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 700,
  textAlign: 'center',
  color: theme.colors.neutral.darkGray,

  marginLeft: theme.spacing(1),
}))

export const PollTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  fontWeight: 700,
  textAlign: 'center',
  marginTop: theme.spacing(3),
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 400,
  textAlign: 'center',
  color: theme.colors.neutral.darkGray,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
}))

export const SubmittedHeaderText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: theme.spacing(1),
}))

export const SubmittedSubtitleText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 400,
  textAlign: 'center',
}))
